<div class="d-flex justify-content-center align-items-center mb-4 d-lg-none">
  <img alt="" src="assets/images/logo-small.svg" class="kid-logo" />
</div>
<h2 class="text-lg-left text-center text-primary mb-2">Add Children</h2>
<p class="heading-text my-4 mt-lg-0">
  If you purchased your King membership in person, please enter the barcode you received to activate your account.
</p>

<fgbcl-errors></fgbcl-errors>

<div class="add-kids-form">
  <div class="child-panel-container">
    <div
      class="p-2 mb-lg-3 mb-1 add-child-panel border border-primary rounded"
      *ngFor="let childForm of childForms; let i = index"
    >
      <form [formGroup]="childForm">
        <div class="form-row">
          <div class="form-group col-lg-4">
            <label for="DateOfBirth" (click)="dobDatePicker.toggle()">Date of Birth<span class="pl-1">*</span></label>
            <input
              class="form-control bg-muted"
              name="DateOfBirth"
              type="text"
              formControlName="DateOfBirth"
              [ngClass]="{
                'is-invalid': hasSubmitted && !!childForm.controls.DateOfBirth.errors
              }"
              ngbDatepicker
              #dobDatePicker="ngbDatepicker"
              [minDate]="{ year: today.getFullYear() - maxAge, month: today.getMonth() + 1, day: today.getDate() + 1 }"
              [maxDate]="{
                year: today.getFullYear() - minAge,
                month: today.getMonth() + 1,
                day: today.getDate()
              }"
              (click)="dobDatePicker.toggle()"
              autocomplete="off"
              required
            />
            <div class="input-group-append position-absolute">
              <button
                class="btn icon icon-calendar text-black font-weight-bold py-0"
                type="button"
                (click)="dobDatePicker.toggle()"
                attr.aria-label="{{ 'registration.add.child.dob.screenreader' | translate }}"
              ></button>
            </div>
            <div class="invalid-feedback">Enter valid Date of Birth.</div>
          </div>
          <div class="form-group col-lg-4">
            <label for="FirstName">First Name<span class="pl-1">*</span></label>
            <input
              id="Firstname"
              class="form-control bg-muted no-border"
              type="text"
              formControlName="Firstname"
              [ngClass]="{
                'is-invalid': hasSubmitted && !!childForm.controls.Firstname.errors
              }"
              required
            />
            <div class="invalid-feedback">Enter child's First Name.</div>
          </div>

          <div class="form-group col-lg-4">
            <label for="Lastname">Last Name<span class="pl-1">*</span></label>
            <input
              id="Lastname"
              class="form-control bg-muted no-border"
              type="text"
              formControlName="Lastname"
              [ngClass]="{
                'is-invalid': hasSubmitted && !!childForm.controls.Lastname.errors
              }"
              required
            />
            <div class="invalid-feedback">Enter child's Last Name.</div>
          </div>
        </div>

        <div class="form-row mb-0">
          <div class="form-group col-lg-7">
            <label for="Barcode">Barcode</label>
            <input
              id="Barcode"
              class="form-control bg-muted no-border"
              type="text"
              formControlName="Barcode"
              [ngClass]="{
                'is-invalid': hasSubmitted && !!childForm.controls.Barcode.errors
              }"
            />
            <div class="invalid-feedback">Enter valid barcode.</div>
          </div>
          <div class="form-group col-lg-2 offset-lg-3" *ngIf="childForms.length > 1">
            <div class="mt-1 d-flex justify-content-center">
              <button
                class="btn btn-danger trash-btn"
                attr.aria-label="{{ 'registration.remove.child.screenreader' | translate }}"
                (click)="removeChild(i)"
              >
                <span class="icon icon-trash"></span>
              </button>
            </div>
            <div class="invalid-feedback"></div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<p class="text-left required-fields-text font-weight-bold d-block">*Required Fields</p>
<div
  *ngIf="childForms.length < childLimit"
  class="mt-2 d-flex align-items-center flex-column add-button-container font-weight-bold"
>
  <button
    class="btn btn-primary btn-circle shadow py-1 px-2 d-flex justify-content-center"
    attr.aria-label="{{ 'registration.add.child.screenreader' | translate }}"
    (click)="addChild()"
  >
    <span class="icon icon-plus font-weight-bold"></span>
  </button>
  <p class="add-text font-size-14 text-primary font-weight-bold text-uppercase mt-1">add another jr.nat</p>
</div>
<div class="button-container position-absolute">
  <fgb-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgb-registration-navigation>
</div>
